import { isPolicyPayoutAnnuity } from "js/utilities";
import DeferredCoverageAndDocuments from "./DeferredCoverageAndDocuments";
import PayoutCoverageAndDocuments from "./PayoutCoverageAndDocuments";

function CoverageAndDocuments(props) {
  const { policy, filteredDocuments } = props;
  if (isPolicyPayoutAnnuity(policy)) {
    return (
      <PayoutCoverageAndDocuments
        policy={policy}
        filteredDocuments={filteredDocuments}
      />
    );
  }

  return (
    <DeferredCoverageAndDocuments
      policy={policy}
      filteredDocuments={filteredDocuments}
    />
  );
}

export default CoverageAndDocuments;
